
import swal from 'sweetalert';
import actions from './redux/actions';
import { LOCAL_STORAGE_KEY } from '@xavisoft/auth/constants';
import L from 'leaflet';
import marker from './media/pin-svgrepo-com.svg';

function decodeJWT(token) {
	const base64Url = token.split('.')[1];
	const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));

	return JSON.parse(jsonPayload);
}

function delay(millis) {
   return new Promise(resolve => setTimeout(resolve, millis));
}

function requestConfirmation(question, {
	title="Confirm",
   confirmButtonCaption='Yes',
   cancelButtonCaption="Cancel",
}={}) {
   return swal({
		title,
		icon: "warning",
      text: question,
      buttons: [
         {
            text: confirmButtonCaption,
            value: true,
            className: "bg-red-600 text-white",
            visible: true,
         },
         {
            text: cancelButtonCaption,
            value: false,
            visible: true,
            className: "bg-white text-red-600 border-none"
         }
      ],
      closeOnClickOutside: false,
      closeOnEsc: false,
   });
}

function deepEqual(obj1, obj2) {
   if (obj1 === obj2)
      return true ;

   // literals
   if (Number.isNaN(obj1) && Number.isNaN(obj2))
      return true;

   if (typeof obj1 !== 'object' || typeof obj2 !== 'object')
      return false;

   const obj1Keys = Object.keys(obj1), obj2Keys = Object.keys(obj2);

   if (obj1Keys.length !== obj2Keys.length)
      return false;

   for (const key of obj1Keys) {
      if (!deepEqual(obj1[key], obj2[key]))
         return false;
   }

   return true;

}

function returnChangedAttributes(payload, original) {
   const changed = {};
   Object.keys(payload).forEach(key => {
      if (typeof payload[key] === 'object') {
         if (!deepEqual(payload[key], original[key]))
            changed[key] = payload[key];
      } else {
         if (payload[key] !== original[key])
            changed[key] = payload[key];
      }
   });

   return changed;
}

function logout() {
   // remove jwt tokens
   localStorage.removeItem(LOCAL_STORAGE_KEY);

   // set auth status to false
   actions.setAuthenticated(false);
   actions.setUser(null);

   // navigate to login
   window.App.redirect('/login');
}

function createMarkerIcon() {
   return new L.Icon({
      iconUrl: marker,
      iconRetinaUrl: marker,
      popupAnchor:  [ 0, 0],
      iconSize: [32,45], 
      iconAnchor: [16, 45],
   });

}

function isRouteLogin(route) {
   return route === '/login' || route === '/';
}

function formatDateForDateInput(date) {
   if (!date)
      return '';

   // return if already in the correct format
   if (date.match(/^\d{4}-\d{2}-\d{2}$/))
      return date;

   const d = new Date(date);
   const year = d.getFullYear();
   const month = String(d.getMonth() + 1).padStart(2, '0');
   const day = String(d.getDate()).padStart(2, '0');

   return `${year}-${month}-${day}`;
}


/**
 * 
 * @param {File | Blob} file 
 * @returns {Promise<{name: string, base64: string, ext: string, url: string}>}
 */
function getFileData(file) {

   const reader = new FileReader();
   reader.readAsDataURL(file);

   return new Promise((resolve, reject) => {
      reader.onload = () => {
         const url = reader.result;
         const base64 = url.split(',')[1];
         const name = file.name || 'Blob';
         const ext = file instanceof Blob ? file.type.split('/')[1] : file.name.split('.').pop();
         resolve({ name, base64, ext, url });
      }

      reader.onerror = (err) => {
         reject(err);
      }
   });
}


export {
   createMarkerIcon,
	decodeJWT,
   delay,
   formatDateForDateInput,
   getFileData,
   isRouteLogin,
   logout,
	requestConfirmation,
   returnChangedAttributes
}